import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './Chimney.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
// images
import AreaData from './AreaData'
import LocationReviewsData from './LocationReviewsData'
import ReactCompareImage from "react-compare-image";
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import emailjs from 'emailjs-com';
import img22 from '../../Images/222.jpg'
import img23 from '../../Images/333.jpg'

export default function Chimney({ CitiePhone, locationsMain, CitiesData }) {

    const [Service, setService] = useState(true);
    const location = useLocation()
    const navigate = useNavigate()
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const [response, setResponse] = useState({});
    const url = new URL(window.location.href);
    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    // Faqs
    const data = {
        title: "",
        rows: [
            {
                "title": "WHY CHOOSE AttiAir?",
                "content": "AttiAir is your trusted source for complete chimney and fireplace care. With years of hands-on experience, we specialize in inspections, repairs, and maintenance to keep your chimney and fireplace safe and fully functional. Our team is committed to delivering reliable, high-quality service with a focus on safety, efficiency, and customer satisfaction."
            },
            {
                "title": "WHAT CHIMNEY & FIREPLACE SERVICES DO YOU OFFER?",
                "content": "We provide a wide range of services to protect and maintain your system, including damper repair, pilot light repair, chimney inspections, fireplace repairs, chimney cap installations, liner replacements, and full fireplace rebuilds. Our goal is to keep your fireplace running safely and your home protected year-round."
            },
            {
                "title": "HOW MUCH DO YOUR SERVICES COST?",
                "content": "Our chimney inspections $69. Damper and pilot light repairs are priced based on the complexity of the issue, and we provide free, upfront estimates before any work begins. You’ll always know what to expect with clear and honest pricing."
            },
            {
                "title": "CAN YOU REPAIR AND INSPECT DURING THE SAME VISIT?",
                "content": "Yes! During your chimney or fireplace inspection, if we find issues with your damper, pilot light, or structural components, we can often complete the repairs the same day. This saves you time and ensures your system is safe and fully operational as quickly as possible."
            },
            {
                "title": `DO YOU PROVIDE SERVICES IN ${CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "YOUR AREA"}?`,
                "content": `Yes, we proudly serve ${CitiesData && CitiesData.City ? CitiesData.City : "your area"} and surrounding communities within a 75-mile radius. Whether you need a routine inspection or urgent fireplace repair, our team is ready to help keep your home safe and comfortable.`
            },
            {
                "title": "HOW DO I BOOK AN APPOINTMENT?",
                "content": `Booking with AttiAir is quick and easy! Call us at <a href='tel:${CitiePhone}'>${CitiePhone}</a> or use our <a href='#book'>online booking form</a>. We’ll confirm your appointment and make sure a technician is scheduled at a time that's convenient for you.`
            },
            {
                "title": "HOW OFTEN SHOULD I HAVE MY CHIMNEY INSPECTED?",
                "content": "The National Fire Protection Association (NFPA) recommends a professional chimney inspection at least once a year, especially before the start of the burning season. Inspections help identify hazards like creosote buildup, blockages, or structural issues before they become dangerous."
            },
            {
                "title": "WHY IS FIREPLACE & CHIMNEY REPAIR IMPORTANT?",
                "content": "Repairing issues like a faulty damper, malfunctioning pilot light, or cracked firebox keeps your fireplace operating safely and efficiently. Regular maintenance and timely repairs reduce fire risks, prevent smoke and gas leaks, and help your system last longer."
            }
        ]
    };

    const styles = {
        bgColor: '#f3f3f3',
        titleTextColor: '#222222',
        titleTextSize: '18px',
        rowTitleColor: '#222222',
        rowTitleTextSize: '19px',
        rowContentColor: '#242424',
        rowContentTextSize: '17px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "AttiAir" can help our clients with that kind of service, give me that as json file: title 3 words (include in the title words from the keyword, remove null and AttiAir from title)(if no keywords just do for chhimney sweep) and body`
                const apiKey = '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'; // Replace with your actual API key
                const resChat = await fetch(`https://api.openai.com/v1/chat/completions`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiKey}`,
                    },
                    body: JSON.stringify({
                        'model': 'gpt-3.5-turbo',
                        'messages': [
                            {
                                'role': 'user',
                                'content': searchKeyword
                            }
                        ]
                    })
                })
                const dataChat = await resChat.json()

                setResponse(JSON.parse(dataChat.choices[0].message.content))
            } catch (error) {
                console.log(error);
            }

            const getDerivedStateFromError = (error) => {
                console.log("123123");
                return { hasError: true };
            }
            const dsad = (error, errorInfo) => {
                console.log("123123");
            }
        })();
    }, []);
    return (
        <div className="Chimney" id="homepage">
<Helmet>
    {/* <!-- TITLE (Max 65 characters) --> */}
    <title>AttiAir - Chimney Cleaning & Repair | Fireplace & Flue Services | 866-257-5796</title>

    {/* <!-- META TITLE (Max 35 characters) --> */}
    <meta name="title" property="title" content="AttiAir - Chimney Cleaning & Repair | Fireplace & Flue Services | 866-257-5796" data-react-helmet="true" />
    <meta name="og:title" property="og:title" content="AttiAir - Chimney Cleaning & Repair | Fireplace & Flue Services | 866-257-5796" data-react-helmet="true" />

    {/* <!-- META DETAILS --> */}
    <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
    <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
    <meta name="og:image" property="og:image" content="https://www.attiair.com/images/chimney-og.jpg" data-react-helmet="true" />
    <meta name="og:url" property="og:url" content="https://www.attiair.com/chimney-services" data-react-helmet="true" />

    {/* <!-- META DESCRIPTION (Max 155 characters, First Letter Uppercase) --> */}
    <meta 
        name="description" 
        content="AttiAir Offers Professional Chimney Cleaning, Inspection, Repair, Fireplace Restoration, And Flue Services For A Safer, More Efficient Home." 
        data-react-helmet="true" 
    />
    <meta 
        name="og:description" 
        property="og:description" 
        content="AttiAir Offers Professional Chimney Cleaning, Inspection, Repair, Fireplace Restoration, And Flue Services For A Safer, More Efficient Home." 
        data-react-helmet="true" 
    />

    <meta name="og:site_name" property="og:site_name" content="AttiAir" data-react-helmet="true" />

    {/* <!-- KEYWORDS --> */}
    <meta 
        name="keywords" 
        content="Chimney Cleaning, Chimney Repair, Fireplace Cleaning, Chimney Inspection, Fireplace Repair, Chimney Flue Services, Chimney Liner Repair, Chimney Cap Installation, Fireplace Maintenance, Smoke Chamber Repair, Chimney Sweep, Chimney Leak Fix, Chimney Repointing, Chimney Crown Repair, Fireplace Safety, Flue Installation, Fire Hazard Prevention, Chimney Services Near Me" 
        data-react-helmet="true" 
    />
</Helmet>

            {/* ChimneyMainBanner */}
            <div className="ChimneyMainBanner" >
                <div className="ChimneyMainBannerTopLine">
                    <div className="ChimneyMainBannerTopLineLine"></div>
                    <div className="ChimneyMainBannerTopLineDot"></div>
                    <h1>CHIMNEY & FIREPLACE</h1>
                </div>
                <div className="ChimneyMainBannerTop">
                    <img src={require(`../../Images/Chimneybanner.jpg`)} />
                    <img src={require(`../../ImagesLogos/Logo1.png`)} className="bannerlogohere" />
                    <div className="ChimneyMainBannerTopLEFT"></div>

                </div>
                <div className="ChimneyMainBannerBottom">
                    <div className="ChimneyMainBannerBottomLeft">
                        <h1>The Chimney Experts You've Trusted for Over 20 Years In {CitiesData && CitiesData.City ? CitiesData.Full : "Your Area"}</h1>
                        <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas • <span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', '•') : url.searchParams.get('kd') + "," : ""}</span> Chimney Cleaning and Repair Near Me</h2>
                        <div className="ChimneyMainBannerBottomLeftBtns">
                            <a target='_blank' href={`tel:${CitiePhone}`}>Call Us Now</a>
                            <a target='_blank' href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                        </div>


                        <h4>CHIMNEY AND FIREPLACE SERVICE IN {CitiesData.City ? CitiesData.City.toUpperCase() : "| LOCAL SERVICE"}</h4>
                        <div className="ChimneyMainBannerBottomLeftLine"></div>
                        <p>Fresh air starts with a clean chimney. Over time, soot, creosote, and debris accumulate inside your chimney, blocking proper airflow and posing serious fire hazards. Professional chimney cleaning removes these dangerous buildups, improves ventilation, and helps maintain a safe and comfortable home. A clean chimney means better air circulation, reduced smoke, and peace of mind for you and your family. Regular chimney cleaning is essential for improving your fireplace’s efficiency and preventing costly repairs down the road.</p>
                        <p>Keep your chimney and fireplace working efficiently with expert fireplace repairs. Whether it's fixing cracks in the firebox, repairing or replacing the chimney liner, or restoring the masonry, we offer comprehensive fireplace repair services to restore the beauty and function of your fireplace. A damaged fireplace can lead to heat loss, poor air circulation, and even carbon monoxide buildup, which is dangerous for your family. With our professional repairs, your fireplace will be both safe and efficient, providing warmth and comfort all year round.</p>
                        <div className="MainBannerLeftRatedMain">

                            <div className="Header2Location">
                                <img src={require(`../../Images/place.png`)} alt="" />
                                <h6>{CitiesData.City ? CitiesData.City.toUpperCase() : "Local"}</h6>

                            </div>
                            <div className="MainBannerLeftRated">
                                <h3>Rated 4.9 on Google</h3>
                                <span>
                                    <h4>4.9</h4>
                                    <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="ChimneyMainBannerBottomRight">
                        <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                        <img src={require(`../../Images/banner55.jpeg`)} />
                        <h3><img src={require(`../../Images/stars.png`)} alt="Locally Owned & Operated AttiAir Chimney Sweep Repair" />Locally Owned & Operated</h3>
                        <h3><img src={require(`../../Images/stars.png`)} alt="Licensed | Bonded | Insured AttiAir Chimney Sweep Repair" />Certified | Licensed | Insured</h3>
                        <h3><img src={require(`../../Images/stars.png`)} alt="Satisfaction Guaranteed AttiAir Chimney Sweep Repair" />Satisfaction Guaranteed</h3>

                    </div>
                </div>
            </div>
            {/* ChimneyMainBannerService */}
            <div className="ChimneyMainBannerService">
                <div className="ChimneyMainBannerServiceMenu">
                    <div className="ChimneyMainBannerServiceMenuBox" style={Service ? { "backgroundColor": "white", "borderTop": "8px solid #fcb116" } : { "backgroundColor": "#e4e4e4", "borderTop": "8px solid #fcb116" }} onClick={() => setService(a => true)}>
                        <h1>CHIMNEY SWEEP</h1>
                    </div>
                    <div className="ChimneyMainBannerServiceMenuBox" style={!Service ? { "backgroundColor": "white", "borderTop": "8px solid #fcb116" } : { "backgroundColor": "#e4e4e4", "borderTop": "8px solid #fcb116" }} onClick={() => setService(a => false)}>
                        <h1>FIREPLACE</h1>
                    </div>
                </div>
                {Service ?
                    <div className="ChimneyMainBannerServiceInfo">
                        <div className="ChimneyMainBannerServiceInfoTop">
                            <div className="ChimneyMainBannerServiceInfoLeft">
                                <h1>CHIMNEY SWEEP SERVICE</h1>
                                <img src={require(`../../Images/Chimney1.jpeg`)} />
                            </div>
                            <div className="ChimneyMainBannerServiceInfoRight">
                                <div className="ChimneyBenefitsBox">
                                    <div className="ChimneyBenefitsBoxImg">
                                        <img src={require(`../../Images/ben2.png`)} alt="Smoke Issues" />
                                    </div>
                                    <div className="ChimneyBenefitsBoxBox">
                                        <h2>Smoke Backing Up Into Your Home?</h2>
                                        <h3>Blocked or dirty chimneys can cause smoke to enter your living space. Our professional chimney sweep service clears out soot and debris, ensuring proper ventilation and a safer home. We also offer expert chimney repairs to address any structural damage and improve airflow.</h3>
                                    </div>
                                </div>

                                <div className="ChimneyBenefitsBox">
                                    <div className="ChimneyBenefitsBoxImg">
                                        <img src={require(`../../Images/ben3.png`)} alt="Odor Issues" />
                                    </div>
                                    <div className="ChimneyBenefitsBoxBox">
                                        <h2>Unpleasant Fireplace Odors?</h2>
                                        <h3>Creosote and soot buildup can create strong, unpleasant smells. Our thorough chimney cleaning removes odor-causing residue, leaving your home fresher and more comfortable. We also check and repair chimney caps to prevent odors from escaping.</h3>
                                    </div>
                                </div>

                                <div className="ChimneyBenefitsBox">
                                    <div className="ChimneyBenefitsBoxImg">
                                        <img src={require(`../../Images/ben1.png`)} alt="Fire Risk" />
                                    </div>
                                    <div className="ChimneyBenefitsBoxBox">
                                        <h2>Worried About Chimney Fires?</h2>
                                        <h3>Creosote buildup is the leading cause of chimney fires. Our expert chimney sweeping service removes hazardous buildup, helping you prevent dangerous flare-ups. We also provide chimney repair services to fix any cracks or damage that could lead to a fire hazard.</h3>
                                    </div>
                                </div>

                                <div className="ChimneyBenefitsBox">
                                    <div className="ChimneyBenefitsBoxImg">
                                        <img src={require(`../../Images/ben4.png`)} alt="Energy Loss" />
                                    </div>
                                    <div className="ChimneyBenefitsBoxBox">
                                        <h2>Heat Escaping Too Fast?</h2>
                                        <h3>A poorly maintained chimney can cause drafts and energy loss. We ensure your chimney is sealed, clean, and functioning properly to help maintain indoor comfort and efficiency. We also offer fireplace repairs and chimney cap installations to improve your home’s energy efficiency.</h3>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="BookAnAppointmentMainComponentEmergeryBox">
                            <a target='_blank' href={`tel:${CitiePhone}`}>For emergency service Call: <span>{CitiePhone}</span></a>
                        </div>

                        <div className="MainBanner2Top2" id="ourservices">
                            <div className="MainBanner2TopBox">
                                <div className="MainBanner2TopBoxBack">
                                    {/*  */}
                                </div>
                                <div className="MainBanner2TopBoxMain">
                                    <h2>OUR CHIMNEY SERVICES</h2>
                                    <div className="MainBanner2TopBoxMenu">
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneycleaning.png`)} alt="Chimney Cleaning" />
                                            <h3>Chimney Cleaning</h3>
                                            <h4>Remove Soot & Creosote Buildup</h4>
                                            <h2>Keep your home safe from fires by eliminating dangerous creosote and debris with our thorough chimney sweep services.</h2>
                                        </a>
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneyinspection.png`)} alt="Chimney Inspection" />
                                            <h3>Chimney Inspection</h3>
                                            <h4>Catch Issues Before They Start</h4>
                                            <h2>Our detailed inspections identify structural damage, blockages, and hazards to ensure your chimney is safe and functional.</h2>
                                        </a>
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneyrepair.png`)} alt="Chimney Repair" />
                                            <h3>Chimney Repair</h3>
                                            <h4>Restore Safety & Efficiency</h4>
                                            <h2>We handle everything from minor fixes to major repairs, ensuring your chimney is fully restored and working like new.</h2>
                                        </a>
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneyinspection.png`)} alt="Chimney Cap Installation" />
                                            <h3>Chimney Cap Installation</h3>
                                            <h4>Protect Against Debris & Pests</h4>
                                            <h2>Prevent animals, leaves, and rain from entering your chimney with a secure, professionally installed chimney cap.</h2>
                                        </a>
                                    </div>

                                    <div className="MainBanner2TopBoxMainChat">
                                        <img src={require(`../../ImagesLogos/Logo2.png`)} />
                                        <div className="MainBanner2TopBoxMainChatText">
                                            <h4>{response.title}</h4>
                                            <h3>{response.body}</h3>
                                            <h5>Call us at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> or fill out the <a href={`/book${location.search}`}>online form</a> to schedule your visit.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    :
                    <div className="ChimneyMainBannerServiceInfo">
                        <div className="ChimneyMainBannerServiceInfoTop">
                            <div className="ChimneyMainBannerServiceInfoLeft">
                                <h1>FIREPLACE SERVICES</h1>
                                <img src={require(`../../Images/fireplacebanner.jpg`)} />
                            </div>
                            <div className="ChimneyMainBannerServiceInfoRight">
                                <div className="ChimneyBenefitsBox">
                                    <div className="ChimneyBenefitsBoxImg">
                                        <img src={require(`../../Images/ben2.png`)} alt="Smoke Problems" />
                                    </div>
                                    <div className="ChimneyBenefitsBoxBox">
                                        <h2>Smoke Entering Your Home?</h2>
                                        <h3>Poor fireplace ventilation or blockages can cause smoke to back up into your living space. Our professional chimney cleaning and inspection services ensure safe, proper airflow, and we can also repair any chimney issues to provide a smoke-free home.</h3>
                                    </div>
                                </div>

                                <div className="ChimneyBenefitsBox">
                                    <div className="ChimneyBenefitsBoxImg">
                                        <img src={require(`../../Images/ben3.png`)} alt="Fire Hazards" />
                                    </div>
                                    <div className="ChimneyBenefitsBoxBox">
                                        <h2>Worried About Fire Risks?</h2>
                                        <h3>Creosote buildup in your fireplace increases the chance of dangerous chimney fires. Our thorough fireplace cleaning removes these hazards, and we offer repairs to ensure your chimney and fireplace are in top condition, keeping your home safe.</h3>
                                    </div>
                                </div>

                                <div className="ChimneyBenefitsBox">
                                    <div className="ChimneyBenefitsBoxImg">
                                        <img src={require(`../../Images/ben1.png`)} alt="Efficiency Issues" />
                                    </div>
                                    <div className="ChimneyBenefitsBoxBox">
                                        <h2>Fireplace Not Heating Properly?</h2>
                                        <h3>Blockages, damage, or improper airflow can reduce your fireplace's efficiency. Our expert inspection and chimney repair services restore your system to help you get the most heat from every fire. We ensure your chimney is functioning as it should.</h3>
                                    </div>
                                </div>

                                <div className="ChimneyBenefitsBox">
                                    <div className="ChimneyBenefitsBoxImg">
                                        <img src={require(`../../Images/ben4.png`)} alt="Odor Problems" />
                                    </div>
                                    <div className="ChimneyBenefitsBoxBox">
                                        <h2>Dealing with Musty or Smoky Odors?</h2>
                                        <h3>Lingering odors from soot, creosote, or moisture can make your home uncomfortable. Our professional chimney cleaning and deodorizing services eliminate unpleasant smells, and we inspect and repair your chimney to prevent further odor issues.</h3>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="BookAnAppointmentMainComponentEmergeryBox">
                            <a target='_blank' href={`tel:${CitiePhone}`}>For emergency service Call: <span>{CitiePhone}</span></a>
                        </div>

                        {/* MainBanner2Top2 */}
                        <div className="MainBanner2Top2" id="ourservices">
                            <div className="MainBanner2TopBox">
                                <div className="MainBanner2TopBoxBack">
                                    {/*  */}
                                </div>
                                <div className="MainBanner2TopBoxMain">
                                    <h2>OUR FIREPLACE SERVICES</h2>
                                    <div className="MainBanner2TopBoxMenu">
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneycleaning.png`)} alt="Fireplace Cleaning" />
                                            <h3>Fireplace Cleaning</h3>
                                            <h4>Remove Soot & Creosote Buildup</h4>
                                            <h2>Protect your home from fire hazards and improve airflow with a professional fireplace cleaning.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneyinspection.png`)} alt="Fireplace Inspection" />
                                            <h3>Fireplace Inspection</h3>
                                            <h4>Identify Issues Before They Get Serious</h4>
                                            <h2>We check for structural damage, blockages, and safety risks to ensure your fireplace is ready to use.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneyrepair.png`)} alt="Fireplace Repair" />
                                            <h3>Fireplace Repair</h3>
                                            <h4>Restore Safe & Efficient Operation</h4>
                                            <h2>We repair cracks, gaps, and other issues to keep your fireplace performing safely and efficiently.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneymaintenance.png`)} alt="Fireplace Rebuild" />
                                            <h3>Fireplace Rebuild</h3>
                                            <h4>Complete Restoration Services</h4>
                                            <h2>Whether cosmetic or structural, we provide full rebuild services to give your fireplace a fresh, new look and restore its function.</h2>
                                        </a>
                                    </div>

                                    <div className="MainBanner2TopBoxMainChat">
                                        <img src={require(`../../ImagesLogos/Logo2.png`)} />
                                        <div className="MainBanner2TopBoxMainChatText">
                                            <h4>{response.title}</h4>
                                            <h3>{response.body}</h3>
                                            <h5>Call us at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> or fill out the <a href={`/book${location.search}`}>online form</a> to schedule your visit.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                }
                <h4>TAKE THE FIRST STEP TOWARD A HEALTHIER AND MORE <span>EFFICIENT HOME</span><br /> SCHEDULE YOUR CHIMNEY SERVICE TODAY!</h4>
                <div className="ChimneyBenefitsbutn">
                    <a href={`tel:${CitiePhone}`}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                    <a href='#book'>SCHEDULE <span>&nbsp;ONLINE</span><img src={require(`../../Images/book.png`)} alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection In Master," /></a>
                </div>
            </div>

            {/* ChimneyGoodBY */}
            <div className="ChimneyGoodBY">
                <h1>SAY GOODBYE TO DIRT AND SOOT IN YOUR CHIMNEY</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>Experience cleaner, healthier air with our professional chimneny and fireplace services.</h2>
                <div className="ChimneyGoodBYList">
                    <img src={require(`../../Images/66.jpg`)} />
                    <img src={require(`../../Images/67.jpg`)} />
                    <img src={require(`../../Images/68.jpg`)} />
                    <img src={require(`../../Images/69.jpg`)} />
                </div>
            </div>
            {/* Chimneybefore */}
            <div className="ChimneyBefore">
                <div className="ChimneyBeforeLeft">
                    <h1>THE IMPORTANCE OF CHIMNEY & FIREPLACE CARE</h1>
                    <h2>Protect Your Home, Improve Safety, and Keep Your Fireplace Working at Its Best</h2>
                    <h3>
                        Your chimney and fireplace do more than just keep you warm—they protect your home from fire hazards and ensure clean, efficient operation. Over time, creosote, soot, and debris can build up, leading to blockages, dangerous fire risks, and poor airflow. Without regular care, you might face smoke entering your home, structural damage, or even costly repairs. That’s why our full-service chimney experts are here to help with everything from cleaning to complete rebuilds, making sure your system is safe, efficient, and ready for use all year round.
                    </h3>

                    <h2>Our Chimney & Fireplace Services</h2>
                    <h3>
                        ✔ <b>Chimney Cleaning</b> – Remove dangerous creosote, soot, and debris to reduce the risk of chimney fires and improve air circulation.
                        <br />
                        ✔ <b>Chimney Inspection</b> – Identify cracks, leaks, blockages, and structural issues with a thorough safety inspection.
                        <br />
                        ✔ <b>Chimney Repair</b> – We fix masonry damage, leaks, cracks, and deterioration to restore your chimney's safety and appearance.
                        <br />
                        ✔ <b>Chimney Cap Installation</b> – Keep out rain, animals, and debris with a durable cap designed to protect your chimney year-round.
                        <br />
                        ✔ <b>Chimney Liner Replacement</b> – Protect your home from heat damage and improve draft with a new, properly installed chimney liner.
                        <br />
                        ✔ <b>Fireplace Repair</b> – Whether it’s cracked bricks, damaged dampers, or failing mortar, we restore your fireplace to top condition.
                        <br />
                    </h3>
                    <h4>Booking with AttiAir is simple! Call us at <a href='tel:${CitiePhone}'>{CitiePhone}</a> or complete our <a href='#book'>online booking form</a>. Our team will confirm your appointment and be ready to assist you at your convenience.</h4>
                </div>
                <div className="ChimneyBeforeBox">
                    <ReactCompareImage leftImage={img22} rightImage={img23} />
                </div>
            </div>
            {/* ChimneyReviews */}
            <div className="ChimneyReviews">
                <div className="ChimneyReviewsHeader">
                    <h2>Air Duct Cleaning Reviews:</h2>
                    <h1>Customers are breathing the difference</h1>
                    <div className="ChimneyReviewsHeaderLine"></div>
                </div>
                <div className="ChimneyReviewsMenu">
                    {LocationReviewsData.map((A, index) =>
                        <div key={index} className="ChimneyReviewsMenuBox">
                            <div className="ChimneyReviewsMenuBoxStars">
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                            </div>
                            <h1>{A.review}</h1>
                            <h2>{A.customer}</h2>
                        </div>
                    )}
                </div>
            </div>
            {/* ChimneyBook */}
            <div className="ChimneyBook" id="book">
                <div className="ChimneyReviewsHeader">
                    <h2>Easy & Convenient Booking:</h2>
                    <h1>Schedule Your Service Online!</h1>
                    <div className="ChimneyReviewsHeaderLine"></div>
                </div>
                <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
            </div>
            {/* MainBanner2Top2 */}
            <div className="ChimneyServices">
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <h3>CHIMNEY CLEANING</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/Chimney6.jpeg`)} alt="Chimney Cleaning" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Protect your home with AttiAir’s professional chimney cleaning. We remove dangerous creosote buildup, soot, and debris to reduce fire risks and improve your chimney's performance. Regular cleaning ensures proper airflow and a safer, more efficient fireplace. By maintaining a clean chimney, you can prevent hazardous blockages and ensure smooth, consistent operation of your fireplace. Regular chimney cleaning also helps extend the lifespan of your chimney and prevents costly repairs due to neglected maintenance.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Creosote & Soot Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Blockage Clearing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fire Hazard Reduction</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Improved Draft & Ventilation</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>CHIMNEY REPAIR</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/chimneyrepair.jpg`)} alt="Chimney Repair" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Damaged chimneys can lead to leaks, structural issues, and safety hazards. AttiAir’s chimney repair services fix cracks, bricks, mortar joints, and flashing to restore your chimney’s safety, performance, and appearance. We specialize in addressing issues that could lead to expensive repairs if left unchecked, such as water damage, crumbling masonry, and improper flashing. With our repair services, your chimney will remain structurally sound, safe, and efficient for years to come.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Brick & Mortar Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Water Leak Sealing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Crown & Flashing Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Structural Restoration</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>CHIMNEY CAP INSTALLATION</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/chimneycap.jpeg`)} alt="Chimney Cap Installation" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Prevent water damage, animal entry, and debris buildup with a properly installed chimney cap. AttiAir offers durable, high-quality caps that protect your chimney and extend its lifespan. Chimney caps also help improve the overall efficiency of your fireplace by preventing downdrafts and keeping cold air out. A well-installed chimney cap serves as an essential protective barrier against the elements, ensuring that your chimney remains in optimal condition year-round.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Rain & Moisture Protection</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Animal & Pest Prevention</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Debris Blockage Prevention</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Improved Chimney Lifespan</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>CHIMNEY LINER REPLACEMENT</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/chimneyliner.jpg`)} alt="Chimney Liner Replacement" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Keep your chimney safe and efficient with a new liner. AttiAir’s liner replacement services help protect your home from heat damage, improve draft, and ensure your chimney meets safety standards. A new liner improves airflow, enhances the efficiency of your fireplace, and prevents dangerous backdrafts. It also ensures your chimney is operating within safety codes and protects your home from the risks associated with outdated or damaged liners.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Heat & Fire Protection</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Improved Ventilation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Energy Efficiency Boost</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Extended Chimney Life</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>CHIMNEY INSPECTION</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/chimnneyinspection.webp`)} alt="Chimney Inspection" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Ensure your chimney is safe and operating properly with AttiAir’s comprehensive chimney inspections. We check for blockages, creosote buildup, structural damage, and any hidden hazards. Our thorough inspection includes a detailed assessment of the flue, liner, and chimney structure to identify any potential issues before they become major problems. By catching issues early, you can avoid costly repairs and ensure the continued safe operation of your chimney.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Full Safety Assessment</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Structural Integrity Check</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fire Risk Identification</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Annual Maintenance Report</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>DAMPER REPAIR</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/damperrepair.webp`)} alt="Damper Repair" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Keep smoke out and warmth in with our expert damper repair services. A properly functioning damper improves efficiency, prevents drafts, and keeps your home comfortable year-round. If your damper is damaged, you may be experiencing unwanted drafts, heat loss, or difficulty controlling the airflow in your fireplace. Our repair services restore your damper to optimal function, improving the overall performance and safety of your chimney system.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Smoke & Draft Control</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Energy Loss Prevention</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Improved Fireplace Efficiency</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Replacement & Adjustment</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>PILOT LIGHT REPAIR</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/pilotrepair.jpg`)} alt="Pilot Light Repair" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Having trouble igniting your gas fireplace? Our pilot light repair service restores reliable ignition and ensures your fireplace is safe and ready to use whenever you need it. A malfunctioning pilot light can leave you with an inefficient or non-functioning fireplace, but our technicians are equipped to fix the issue quickly and safely, ensuring your gas fireplace is in full working order.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Ignition Troubleshooting</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Thermocouple Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Pilot Assembly Cleaning</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Safe Gas Flow Testing</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>FIREPLACE REPAIR</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/fireplacerepair.jpg`)} alt="Fireplace Repair" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Restore the beauty and function of your fireplace with AttiAir’s complete fireplace repair services. We fix cracks, replace damaged parts, and ensure your system is both safe and efficient. Whether it’s repairing the firebox, restoring masonry, or making adjustments to the damper or flue, we’ll handle everything to ensure your fireplace operates like new. Our comprehensive fireplace repair services also help improve energy efficiency and the overall safety of your home.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Firebox Crack Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Masonry Restoration</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Damper & Flue Adjustments</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Complete System Inspection</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>AIR DUCT CLEANING AND REPAIR</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/airduct1.png`)} alt="Air Duct Cleaning" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Enhance indoor air quality with AttiAir’s expert air duct cleaning. Over time, dust, pet dander, and allergens accumulate in your ducts, compromising the air you breathe. Our advanced cleaning process removes contaminants, boosts HVAC efficiency, and promotes a healthier home. Whether you're tackling allergies or simply improving airflow, we've got you covered. Trust AttiAir for cleaner air—schedule your service today!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Allergen & Dust Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Duct Sanitization</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Mold & Mildew Treatment</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Air Quality Enhancement</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>DRYER VENT CLEANING AND REPAIR</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/dryercleaned.jpg`)} alt="Dryer Vent Cleaning" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Protect your home from fire hazards and improve efficiency with AttiAir’s expert Dryer Vent cleaning. Over time, lint and debris build up, restricting airflow and increasing safety risks. Our thorough cleaning service removes blockages, restores proper airflow, and helps your dryer run smoothly. Stay safe and save energy—schedule your Dryer Vent cleaning today!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Comprehensive Lint Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Vent Blockage Clearing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fire Hazard Reduction</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Dryer Performance Boost</h2>
                            </div>
                        </div>
                    </a>

                </div>
            </div>



            {/* HomePageGoogleFAQ */}
            <div className="HomePageGoogleFAQ">
                <h1>ABOUT OUR {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : ""} LOCATION</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="HomePageGoogleFAQTop">
                    <div className="HomePageGoogleFAQTopLeft">
                        <h2>PROUDLY SERVING OUR LOCAL COMMUNITY</h2>
                        <div className="HomePageGoogleFAQBorder"></div>
                        <h3>At AttiAir, we are dedicated to providing exceptional service to our community. For over 22 years, we have committed ourselves to delivering top-quality chimney cleaning and repair services throughout {CitiesData && CitiesData.City ? CitiesData.City : ""}, ensuring safer and more comfortable living environments. In addition to chimney cleaning, we also offer a range of services tailored to improve the safety and efficiency of your chimney system, meeting the unique needs of our valued customers.</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                            <a href='#book'>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me AttiAir" /></a>
                        </div>
                    </div>
                    <div className="HomePageGoogleFAQTopRight">
                        <img src={require(`../../ImagesLogos/logobanner.png`)} />
                    </div>
                </div>
                <h1>FREQUENTLY ASKED QUESTIONS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="MainBanner4FaqMore">
                    <Faq
                        data={data}
                        styles={styles}
                        config={config}
                    />
                </div>
            </div>
        </div>
    )
}

